// grantQi: ống DUY NHẤT cộng tu vi (CULTIVATION §4). Tự đột phá tiểu cảnh (có thể nhiều lần),
// dừng ở viên mãn của bước cuối đại cảnh giới; phần vượt thành Dư Khí (trần 25%), dư nữa tan mất.
import { BALANCE } from '@data/balance';
import { ZONE_VEIN_EVENTS } from '@data/content/sites';
import { techniqueDef } from '@data/content/techniques';
import { MAX_STEP, cultCost, overflowCap, stepInfo } from './steps';
import type { CultivationState } from './types';

export interface MinorBreakthrough {
  fromStep: number;
  toStep: number;
  atMs: number;
}

export interface GrantQiResult {
  state: CultivationState;
  breakthroughs: MinorBreakthrough[];
  overflowGained: number;
  /** Tu vi tràn quá cả Dư Khí, tan vào hư không. */
  wasted: number;
  /** Khóa i18n tin Thế Sự của sự kiện thế giới vừa xảy ra (vd linh mạch khô). */
  news: string[];
}

export function grantQi(state: CultivationState, amount: number, atMs: number): GrantQiResult {
  let step = state.step;
  let xp = state.cultivationXp;
  let overflow = state.overflowQi;
  const tri = { ...state.technique.triOrigin };
  const ratio = techniqueDef(state.technique.mainId).ratio;
  const ratioSum = ratio.body + ratio.spirit + ratio.mind;
  const breakthroughs: MinorBreakthrough[] = [];
  const news: string[] = [];
  let overflowGained = 0;
  let wasted = 0;
  let rem = Math.max(0, amount);

  while (rem > 0) {
    const cost = cultCost(step);
    const need = Math.max(0, cost - xp);
    const info = stepInfo(step);
    if (info.isLast || step >= MAX_STEP) {
      if (rem <= need) {
        xp += rem;
      } else {
        xp = cost;
        const spill = rem - need;
        const add = Math.min(spill, Math.max(0, overflowCap(step) - overflow));
        overflow += add;
        overflowGained += add;
        wasted += spill - add;
      }
      rem = 0;
    } else if (rem < need) {
      xp += rem;
      rem = 0;
    } else {
      rem -= need;
      breakthroughs.push({ fromStep: step, toStep: step + 1, atMs });
      step += 1;
      xp = 0;
      // Tam Nguyên: TRI_ORIGIN_PER_STEP điểm mỗi bước, chia theo tỉ lệ công pháp chủ tu.
      const k = BALANCE.TRI_ORIGIN_PER_STEP / ratioSum;
      tri.body += ratio.body * k;
      tri.spirit += ratio.spirit * k;
      tri.mind += ratio.mind * k;
      for (const e of ZONE_VEIN_EVENTS) if (e.fromStep === step) news.push(e.newsKey);
    }
  }

  return {
    state: {
      ...state,
      step,
      cultivationXp: xp,
      overflowQi: overflow,
      technique: { ...state.technique, triOrigin: tri },
    },
    breakthroughs,
    overflowGained,
    wasted,
    news,
  };
}
